module.exports = __webpack_public_path__ + "static/media/carregando.fef1f20a.gif";